import { render, staticRenderFns } from "./ScreenBox.vue?vue&type=template&id=4baff739&scoped=true&"
import script from "./ScreenBox.vue?vue&type=script&lang=js&"
export * from "./ScreenBox.vue?vue&type=script&lang=js&"
import style0 from "./ScreenBox.vue?vue&type=style&index=0&id=4baff739&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baff739",
  null
  
)

export default component.exports